export class TipoEstablecimientoPostRegistro {
  nombre: string;
  codigo: string;
  descripcion: string;
  imagen: string;
}
